import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import BlogCard from 'components/artectum/cards/blog-card';
import { getFeaturedSliderSettings } from 'core/config/slides';
import { useInitialFetch } from 'core/context/initialFetchContext';
import PlaceholderCard from 'components/artectum/cards/PlaceholderCard'; // Importar el componente PlaceholderCard

const BlogSlider = ({ customClass = '', sectionClass = '', title = 'TÚ LO IMAGINAS, NOSOTROS LO HACEMOS' }) => {
    const { projectDataEnteprise, projectDataPersonal, loading } = useInitialFetch();

    return (
        <div className={`ltn__blog-area pt-115--- pb-70 go-top section-bg-1 ${sectionClass}`} style={{ paddingTop: '210px' }}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title-area ltn__section-title-2--- text-center mb-4">
                            <h1 className="section-title">{title}</h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title-area ltn__section-title-2--- text-center mb-0">
                            <h3 className={`ltn__secondary-color section-subtitle ${customClass}`}>
                                Soluciones de Alto Impacto
                            </h3>
                        </div>
                    </div>
                </div>
                {loading ? (
                    <div className="row d-flex justify-content-center">
                        {[...Array(4)].map((_, index) => (
                            <div className="col-md-3 col-sm-6 col-6" key={index}>
                                <PlaceholderCard /> {/* Mostrar el placeholder card mientras se cargan los datos */}
                            </div>
                        ))}
                    </div>
                ) : (
                    projectDataEnteprise?.length > 1 ? (
                        <Slider {...getFeaturedSliderSettings(projectDataEnteprise?.length)} className="row ltn__blog-slider-one-active slick-arrow-1 ltn__blog-item-3-normal">
                            {projectDataEnteprise.map((item, index) => (
                                <div key={index} className="col">
                                    <div className="col-md-12 col-10 m-auto p-0 m-md-0" key={index}>
                                        <BlogCard
                                            image={item.banner_image}
                                            title={item.title}
                                            author={item.autor}
                                            tags={item.tags}
                                            date={item.date}
                                            id={item.id}
                                        />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    ) : (
                        projectDataEnteprise?.map((item, index) => (
                            <div key={index} className="col d-flex justify-content-center">
                                <div className="col col-10 mb-4" key={index}>
                                    <BlogCard
                                        image={item.banner_image}
                                        title={item.title}
                                        author={item.autor}
                                        tags={item.tags}
                                        date={item.date}
                                        id={item.id}
                                        className="m-auto"
                                    />
                                </div>
                            </div>
                        ))
                    )
                )}
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title-area ltn__section-title-2--- text-center mb-0">
                            <h3 className={`ltn__secondary-color section-subtitle  ${customClass}`}>
                                Nos Adaptamos a tu Espacio
                            </h3>
                        </div>
                    </div>
                </div>
                {loading ? (
                    <div className="row d-flex justify-content-center">
                        {[...Array(4)].map((_, index) => (
                            <div className="col-md-3 col-sm-6 col-6" key={index}>
                                <PlaceholderCard /> {/* Mostrar el placeholder card mientras se cargan los datos */}
                            </div>
                        ))}
                    </div>
                ) : (
                    projectDataPersonal?.length > 1 ? (
                        <Slider {...getFeaturedSliderSettings(projectDataPersonal?.length)} className="row ltn__blog-slider-one-active slick-arrow-1 ltn__blog-item-3-normal">
                            {projectDataPersonal.map((item, index) => (
                                <div key={index} className="col">
                                    <div className="col-md-12 col-10 m-auto p-0 m-md-0" key={index}>
                                    <BlogCard
                                        image={item.banner_image}
                                        title={item.title}
                                        author={item.autor}
                                        tags={item.tags}
                                        date={item.date}
                                        id={item.id}
                                        className="mx-auto"
                                    />
                            </div>
                            </div>
                            ))}
                        </Slider>
                    ) : (
                        projectDataPersonal?.map((item, index) => (
                            <div key={index} className="col d-flex justify-content-center">
                                <div className="col col-10 mb-4" key={index}>
                                <BlogCard
                                    image={item.banner_image}
                                    title={item.title}
                                    author={item.autor}
                                    tags={item.tags}
                                    date={item.date}
                                    id={item.id}
                                    className="mx-auto"
                                    />
                            </div>
                            </div>
                        ))
                    )
                )}
            </div>
        </div>
    );
};

BlogSlider.propTypes = {
    customClass: PropTypes.string,
    sectionClass: PropTypes.string,
    title: PropTypes.string
};

export default BlogSlider;